import { Component, OnInit } from '@angular/core';
import {faChevronRight} from '@fortawesome/free-solid-svg-icons';
import * as FileSaver from 'file-saver-es';
import { DashboardService } from 'src/app/services/dashboard.service';
import { formatDate } from '@angular/common';
import { faCreativeCommonsSamplingPlus } from '@fortawesome/free-brands-svg-icons';
import { ReportsCommonService } from 'src/app/services/reports-common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-reports-dashboard',
    templateUrl: './reports-dashboard.component.html',
    styleUrls: ['./reports-dashboard.component.scss'],
    standalone: false // NOSONAR
})
export class ReportsDashboardComponent implements OnInit {

  faChevronRight = faChevronRight;
  dialogRef: any;
  curDate = formatDate(new Date(), 'yyyyMMdd', 'en');
  errorMessage: any;
  successMessage: any;
  datalist: any;
  isAccessible=true;

  constructor( private  readonly dashboardService : DashboardService, 
    private readonly commonService : ReportsCommonService,
     private readonly  ngxUiLoaderService : NgxUiLoaderService,
    public constants: Constants,  private readonly aetStateService : AetStateService, private readonly router: Router) { }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    // this.checkRoles();
    this.ngxUiLoaderService.stop(CommonConstant.loader);
  }



  commonApiCall() {
    this.successMessage=null;
    this.errorMessage=null;
  const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.commonService.getCommonReportByUser(userInfo)
      .subscribe(
        (response: any) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.datalist = response
          this.commonService.updateTrialChanges(this.datalist)
          
        },
        _error => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = "Failed";
        }
      )
  }

  downloads() {
    this.successMessage=null;
    this.errorMessage=null;
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.ngxUiLoaderService.start(CommonConstant.loader);
    console.log('User Info for report generation:', userInfo);
    this.dashboardService?.getreport(userInfo)
      .subscribe({
        next: (response) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          const filename = "AET-Dashboard-" + this.curDate
          const data: Blob = new Blob([(<any>response)?.body], { type: 'application/vnd.ms-excel' });
          FileSaver.saveAs(data, filename);
        },
        error: () => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = this.constants.downloadError;
          
        }
      })
  }

}
